// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import questionOpinionEntity from './entities/question-opinion.json';
import questionOpinionMenu from '../pages/question-opinion/menu.json';
import questionOpinionFullForm from '../pages/question-opinion/forms/full.json';
import questionOpinionContextForm from '../pages/question-opinion/forms/context.json';
import questionOpinionMiniForm from '../pages/question-opinion/forms/mini.json';
import questionOpinionLookupForm from '../pages/question-opinion/forms/lookup.json';
import questionOpinionTableView from '../pages/question-opinion/views/table.json';
import questionOpinionCardsView from '../pages/question-opinion/views/cards.json';
import questionOpinionDashboardView from '../pages/question-opinion/views/dashboard.json';

/** Тип запису «Юридичний висновок» зі сторінками пакета: меню, форми та подання з pages/question-opinion/. */
export const questionOpinionDefinition: IRecordTypeDefinition = {
  ...questionOpinionEntity,
  views: assembleViewSet({
      table: questionOpinionTableView,
      cards: questionOpinionCardsView,
      dashboard: questionOpinionDashboardView,
  }),
  form: questionOpinionFullForm,
  forms: { full: questionOpinionFullForm, context: questionOpinionContextForm, mini: questionOpinionMiniForm, lookup: questionOpinionLookupForm },
  menu: questionOpinionMenu,
} as IRecordTypeDefinition;
